import React from "react";
import { Loading } from "../../components";
import { UserRole } from "../../__generated__/globalTypes";
import { NotFound } from "../404";
import { useMe } from "../users/hooks/useMe";
import { Admin, Customer } from "./pages";

export const Dashboard: React.FC = () => {
  const { data, loading } = useMe();

  if (loading) return <Loading />;
  if (!data?.me) return <NotFound />;

  if (data?.me?.role === UserRole.Admin) {
    return <Admin />;
  }

  return <Customer />;
};
